export enum StoresList {
  APPLICATION = 'application',
  ADMIN = 'admin',
  USER = 'user',
  ACTORS = 'actors',
  HIGHLIGHTS = 'highlights',
  PROJECTS = 'projects',
  ATLAS = 'atlas',
  RESOURCES = 'resources',
  THEMATICS = 'thematics',
  HOME = 'home',
  MY_MAP = 'myMap',
  ADMINISTRATIVE_BOUNDARIES = 'administrativeBoundaries',
  COMMENT = 'comment',
  DOMAINE = 'domaine',
  SOUS_DOMAINE = 'sousDomaine',
  COMPETENCE = 'competence',
  ATTRIBUT = 'attribut',
  DASHBOARD = 'dashboard',
}
